module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home */

(function(fox) {
    fox.registerWidget('Layout_Join', {

        addedToDom: function () {
            $('.wrapper').css('paddingBottom', 0)
        }
    }, 'Site_Layout');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/layout/join.js
// module id = 1127
// module chunks = 4